import React, { useEffect } from "react";

function Success(props) {
	useEffect(() => {
		const timeoutId = setTimeout(props.hideModal, 4000);

		window.gtag("event", "conversion", {
			send_to: "AW-11286585168/dwqMCMfNhs0YENC-7oUq",
		});

		return () => clearTimeout(timeoutId);
	}, [props.hideModal]);

	return (
		<div className="text-center">
			<h3 className="h2 layout_mb__30">VIELEN DANK FÜR DEINE ANMELDUNG!</h3>
			<div
				className="layout_iframe layout_iframe__small layout_mb__30"
				dangerouslySetInnerHTML={{
					__html: `<iframe src="https://giphy.com/embed/K7EQ8M8TnuBby" width="100%" height="100%" style="position:absolute" frameBorder="0" class="giphy-embed" allowFullScreen></iframe>`,
				}}
			></div>
			<p className="layout_text layout_mb">
				Vielen Dank für Deine Voranmeldung.
				<br />
				Wir melden uns bald bei Dir ;)
			</p>
			<h4>Bis bald!</h4>
		</div>
	);
}

export default Success;
